// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e293d23d","732":"e6038724"}[chunkId] + ".chunk.js";
};